import { LoadingButton } from 'components/form';
import React, { useState } from 'react';
import { IoMdTime } from "react-icons/io";
import { useSelector } from 'react-redux';
import { indFormatPrice } from 'utils/commonFun';
import { failMessage } from 'utils/toastMessage';
import { initiatePaymentApi } from 'services/dashboard';
import { loadCashfree } from 'utils/cashFree';

const BillDue = ({ orderId }) => {
  const { selectedSite } = useSelector((state) => state?.selectedSite);
  const { user } = useSelector((state) => state.userProfile);
  const [loading, setLoading] = useState(false);
  // console.log(' Bill deu', orderId)

  // ------------initiate-Payment-Api---------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    try {
      const response = await initiatePaymentApi({ plantId: selectedSite?._id });
      // console.log('Cashfree order response:', response);

      const paymentSessionId = response?.data?.payment_session_id;

      if (paymentSessionId) {
        const cashfree = await loadCashfree(); // loads v3 SDK

        await cashfree.checkout({
          paymentSessionId,
          redirectTarget: "_modal", //_modal or _self or "_blank" to open in new tab
        });
      } else {
        failMessage(response?.message || "Failed to initialize payment.");
      }

    } catch (err) {
      console.error("Payment error:", err);
      // failMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  // console.log('user', user)
  return (
    <>
      {user?.billingSummary?.pendingAmount > 0 && (
      <div className="due_bill_section">
        <div className="bill_amount">
          <span>Bill Due</span>
          <h4>{indFormatPrice(user?.billingSummary?.pendingAmount)}</h4>
        </div>
        <div className="payNow">
          <p><IoMdTime /> {user?.billingSummary?.dueStatus}</p>
          <LoadingButton
            disabled={loading || user?.billingSummary?.pendingAmount === 0}
            loading={loading}
            onClick={handleSubmit}
          >
            Pay Now
          </LoadingButton>
        </div>
      </div>
      )} 
    </>
  );
};

export default BillDue;